import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@shared/api';

/** GET /cabinet/home — данные Главной и статусы ассистентов для левого меню (V2-4). */
export interface HomeAssistant {
  id: string;
  name: string;
  status: 'working' | 'stopped' | 'no_balance';
  model: { id: number; title: string; vendor_code: string | null; data_in_russia: boolean } | null;
  sources: number;
  sources_ready: number;
  channels: { site: boolean; telegram: boolean; max: boolean; api: boolean };
  answers_7d: number;
}

export interface HomeDialog {
  id: string;
  assistant_id: string;
  name: string | null;
  platform: 'widget' | 'telegram' | 'max';
  last_question: string | null;
  last_message_at: string | null;
  unanswered: boolean;
}

export interface HomeData {
  balance: number;
  answers_7d: number;
  answers_7d_test_only: boolean;
  assistants: HomeAssistant[];
  recent_dialogs: HomeDialog[];
  checklist: { kb_tested: boolean; messenger: boolean; models: boolean };
}

export const homeQueryKeys = { home: ['cabinet', 'home'] as const };

export function useHome() {
  return useQuery<HomeData, Error>({
    queryKey: homeQueryKeys.home,
    queryFn: async () => (await httpClient.get<HomeData>('/cabinet/home')).data,
    staleTime: 20_000,
  });
}
